<template>
  <FlexCol gap-1>
    <Label :label="label" :required="required" :error="error" v-if="label" />
    <Input
      v-model="localValue"
      :error="error"
      :placeholder="props.placeholder ?? '00:00'"
      :disabled="props.disabled"
      mask="##:##">
      <template #pre-icon>
        <Flex center class="w-[42px] h-full border-r font-bold bg-gray-100">
          <IconSolid icon="fa-clock" />
        </Flex>
      </template>
    </Input>
    <Error :message="error" v-if="error" />
  </FlexCol>
</template>

<script setup>
import { watch, ref } from 'vue'

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: [String, Number],
  placeholder: String,
  min: String,
  max: String,
})

const emits = defineEmits(['update:modelValue'])
const localValue = ref(props.modelValue)
const error = ref(props.error)

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  }
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  }
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
